import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { useCountryName } from "../../../../components/AddressInput";

export function PassportSummaryField({
  field,
}: {
  field: components["schemas"]["PassportCheckField"];
}) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();

  return (
    <>
      <InnerContentItem
        label={t("ID number")}
        testID="passport-summary-passport-number"
      >
        {field.value?.document_number}
      </InnerContentItem>

      <InnerContentItem
        label={t("ID expiration")}
        testID="passport-summary-passport-expiration"
      >
        {formatDate(field.value?.document_expiration, "MMMM d, yyyy")}
      </InnerContentItem>

      <InnerContentItem
        label={t("Issuing country")}
        testID="passport-summary-country-of-issue"
      >
        {field.value?.document_issuing_country
          ? getCountryName(field.value.document_issuing_country)
          : "-"}
      </InnerContentItem>

      <InnerContentItem
        label={t("Issuing province, state or territory")}
        testID="passport-summary-state-or-territory-of-issue"
      >
        {field.value?.document_issuing_province_state}
      </InnerContentItem>
    </>
  );
}
